<template>
    <div v-if="tutorials.length" class="tutorial-btn-wrap">
        <!-- Standalone, easy-to-spot Tutorial button -->
        <a href="javascript:void(0)" class="tutorial-btn mal-text" @click="openSheet">
            <ion-icon name="play-circle" class="tutorial-btn-icon"></ion-icon>
            <span class="tutorial-btn-text">{{ $t('tutorials') || 'Tutorials' }}</span>
            <span class="tutorial-btn-count">{{ tutorials.length }}</span>
        </a>

        <!-- Bottom-sheet list of tutorials -->
        <div class="modal fade action-sheet" :id="modalId" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mal-text">{{ $t('tutorials') || 'Tutorials' }}</h5>
                    </div>
                    <div class="modal-body">
                        <div class="action-sheet-content">
                            <a v-for="item in tutorials" :key="item.id" :href="item.link" target="_blank"
                                rel="noopener" class="tutorial-row" @click="closeSheet">
                                <div class="tutorial-row-icon">
                                    <ion-icon name="play-circle-outline"></ion-icon>
                                </div>
                                <div class="tutorial-row-text">
                                    <strong class="mal-text">{{ item.title_mal || item.title }}</strong>
                                    <p class="mal-text" v-if="item.description">{{ item.description }}</p>
                                </div>
                                <ion-icon name="open-outline" class="tutorial-row-arrow"></ion-icon>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
import UserService from "../services/user.service";

export default {
    name: "TutorialButton",
    props: {
        // Only tutorials with this category are shown (e.g. "Youth Dawa Fund")
        category: { type: String, default: null },
        id: { type: String, default: "tutorialSheet" },
        // Level of the page being viewed (2=district, 3=zone, 4=unit).
        // Controls which tutorials show, based on the page context — NOT the
        // logged-in user's own level (a state admin drilling into a zone page
        // should see zone tutorials, not everything). Falls back to the user's
        // own level when not supplied.
        level: { type: [Number, String], default: null },
    },
    data() {
        return {
            tutorials: [],
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        modalId() {
            return this.id;
        },
    },
    methods: {
        load() {
            if (!this.currentUser) return;
            const effectiveLevel = (this.level !== null && this.level !== '')
                ? Number(this.level)
                : this.currentUser.user_level;
            let data = { level: effectiveLevel };
            if (this.category) data.category = this.category;
            UserService.authPostRequest(`get-tutorials`, data).then(
                (response) => {
                    if (response.data.status == "success") {
                        this.tutorials = response.data.data.list;
                    }
                },
                () => {}
            );
        },
        openSheet() {
            try {
                // eslint-disable-next-line no-undef
                if (typeof bootstrap !== "undefined" && bootstrap.Modal) {
                    // eslint-disable-next-line no-undef
                    new bootstrap.Modal(document.getElementById(this.modalId)).show();
                    return;
                }
            } catch (e) { /* fall through */ }
            $("#" + this.modalId).modal("show");
        },
        closeSheet() {
            try {
                // eslint-disable-next-line no-undef
                if (typeof bootstrap !== "undefined" && bootstrap.Modal) {
                    // eslint-disable-next-line no-undef
                    const inst = bootstrap.Modal.getInstance(document.getElementById(this.modalId));
                    if (inst) { inst.hide(); return; }
                }
            } catch (e) { /* fall through */ }
            $("#" + this.modalId).modal("hide");
        },
    },
    mounted() {
        this.load();
    },
};
</script>
<style scoped>
.tutorial-btn-wrap { display: inline-block; }
.tutorial-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: #6d28d9;
    background: linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%);
    color: #fff;
    border-radius: 24px;
    padding: 8px 14px;
    text-decoration: none;
    font-size: 13px;
    font-weight: 700;
    box-shadow: 0 3px 10px rgba(109, 40, 217, 0.35);
}
.tutorial-btn:active { transform: scale(0.98); }
.tutorial-btn-icon { font-size: 18px; }
.tutorial-btn-text { line-height: 1; }
.tutorial-btn-count {
    background: rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    font-size: 11px;
    font-weight: 800;
    min-width: 18px;
    height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 5px;
}

/* rows inside the sheet */
.tutorial-row {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 15px 4px;
    border-bottom: 1px solid #f1f3f7;
    text-decoration: none;
}
.tutorial-row:last-child { border-bottom: 0; }
.tutorial-row-icon {
    width: 46px;
    height: 46px;
    border-radius: 10px;
    background: #f1eafe;
    color: #6d28d9;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.tutorial-row-icon ion-icon { font-size: 28px; }
.tutorial-row-text { flex: 1; min-width: 0; }
.tutorial-row-text strong { font-size: 17px; color: #27173E; display: block; line-height: 1.3; }
.tutorial-row-text p { font-size: 14px; color: #6b7280; margin: 3px 0 0; line-height: 1.4; }
.tutorial-row-arrow { font-size: 22px; color: #6d28d9; flex-shrink: 0; }
</style>
